module.exports = __webpack_public_path__ + "static/img/ydzz.ccf27ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/ydzz.png
// module id = SgJr
// module chunks = 1